
    import '/Users/jilin/projects/antd/rc-dialog/docs/demo/ant-design.md?watch=parent';
    export const toc = [];
export const frontmatter = {"title":"ant-design","toc":"menu","filename":"docs/demo/ant-design.md","lastUpdated":1674027995000,"nav":{"title":"Demo","path":"/demo"}};